/*
 * INDRAAZ — one dots carousel for the whole site.
 *
 * Upgrades any horizontally scrolling row to Instagram-style dots and hides
 * the stock arrows and "1 / 5" counter. Works on two kinds of target:
 *
 *   1. Dawn's <slider-component>, which already scrolls a .slider list.
 *   2. Anything tagged data-idz-carousel, for our own rails.
 *
 * Opt out with data-idz-carousel="off" on the slider-component.
 *
 * Dots are per scroll position, not per item, so a rail showing two cards at a
 * time gets one dot per pair.
 */
(function () {
  if (window.__idzCarouselBound) return;
  window.__idzCarouselBound = true;

  var MIN_ITEMS = 2;

  function railOf(host) {
    return host.querySelector('.slider, [data-idz-rail], .idz-rail');
  }

  function itemsOf(rail) {
    return Array.prototype.filter.call(rail.children, function (el) {
      return el.nodeType === 1 && el.offsetParent !== null;
    });
  }

  function build(host) {
    if (host.dataset.idzCarousel === 'off' || host.dataset.idzDotsReady) return;

    var rail = railOf(host);
    if (!rail) return;

    var items = itemsOf(rail);
    if (items.length < MIN_ITEMS) return;

    // Only worth dots if the row actually overflows.
    if (rail.scrollWidth <= rail.clientWidth + 4) return;

    host.dataset.idzDotsReady = 'true';
    host.classList.add('idz-has-dots');

    var dots = document.createElement('div');
    dots.className = 'idz-dots';
    dots.setAttribute('role', 'tablist');
    dots.setAttribute('aria-label', host.dataset.idzLabel || 'Carousel');
    // Directly after the rail, so the dots stay attached to what they scroll
    // rather than landing under a "View all" link further down the panel.
    if (rail.parentNode) {
      rail.parentNode.insertBefore(dots, rail.nextSibling);
    } else {
      host.appendChild(dots);
    }

    function pages() {
      // Capped at 2 so wide desktop rails still land on a handful of dots
      // instead of collapsing a long row down to two or three.
      var per = Math.max(1, Math.min(2, Math.round(rail.clientWidth / items[0].offsetWidth)));
      return Math.max(1, Math.ceil(items.length / per));
    }

    function render() {
      var count = pages();
      if (dots.childElementCount !== count) {
        dots.innerHTML = '';
        lastActive = -1;
        for (var i = 0; i < count; i++) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'idz-dots__dot' + (i === 0 ? ' is-active' : '');
          b.dataset.idzPage = i;
          b.setAttribute('role', 'tab');
          b.setAttribute('aria-label', 'Go to page ' + (i + 1));
          dots.appendChild(b);
        }
      }
      dots.hidden = count < 2;
    }

    // scroll fires far more often than the active dot actually changes —
    // skipping the DOM write when it hasn't avoids doing real work (style
    // recalc from classList/aria writes) on every one of those events.
    var lastActive = -1;

    function sync() {
      var count = dots.childElementCount;
      if (!count) return;
      var max = rail.scrollWidth - rail.clientWidth;
      var ratio = max > 0 ? rail.scrollLeft / max : 0;
      var active = Math.round(ratio * (count - 1));
      if (active === lastActive) return;
      lastActive = active;
      Array.prototype.forEach.call(dots.children, function (dot, i) {
        dot.classList.toggle('is-active', i === active);
        dot.setAttribute('aria-selected', i === active ? 'true' : 'false');
      });
    }

    dots.addEventListener('click', function (event) {
      var dot = event.target.closest('[data-idz-page]');
      if (!dot) return;
      var count = dots.childElementCount;
      var max = rail.scrollWidth - rail.clientWidth;
      var i = parseInt(dot.dataset.idzPage, 10);
      rail.scrollTo({ left: count > 1 ? (max * i) / (count - 1) : 0, behavior: 'smooth' });
    });

    rail.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', function () {
      render();
      sync();
    });

    render();
    sync();
  }

  function scan(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('slider-component, [data-idz-carousel]').forEach(build);
  }

  function start() {
    scan(document);

    // Sections can arrive later — theme editor edits, recommendations, apps.
    new MutationObserver(function (records) {
      records.forEach(function (record) {
        record.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.matches && node.matches('slider-component, [data-idz-carousel]')) build(node);
          scan(node);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
